<template>
<div>
  <div class="container">
    <tit class="title">买手</tit>
    <el-carousel class="carousel" indicator-position="outside" trigger="click" height="270px" v-if="screenWidths >1024 ">
      <el-carousel-item v-for="(itemlist,listindex) in 1" :key="listindex">
        <el-row :gutter="0" style="width: 80%;margin: 0 auto;margin-top: 20px;">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" class="text-center" v-for="(item,index) in buyers" :key="index">
            <img :src="item.imgsrc" class="buyerimg" />
            <h3 class="buyername">{{item.buyername}}</h3>
            <p>{{item.detail}}</p>
          </el-col>
        </el-row>
      </el-carousel-item>
    </el-carousel>

    <el-carousel class="carousel" indicator-position="outside" trigger="click" height="270px" v-else-if="screenWidths >=768 ">
      <el-carousel-item>
        <el-row :gutter="0" style="width: 80%;margin: 0 auto;margin-top: 20px;">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" class="text-center">
            <img src="../../assets/images/buyer/01.jpeg" class="buyerimg" />
            <h3 class="buyername">Joy</h3>
            <p>新手推荐买手，汇率优惠高，服务周到完善，有问必答。</p>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" class="text-center">
            <img src="../../assets/images/buyer/02.jpeg" class="buyerimg" />
            <h3 class="buyername">iwaving </h3>
            <p>人在国内，拥有美卡，英文口语流利，一年多下单经验，涉及200多个商家，能下单部分美卡美私的商家。</p>
          </el-col>
        </el-row>
      </el-carousel-item>
      <el-carousel-item>
        <el-row :gutter="0" style="width: 80%;margin: 0 auto;margin-top: 20px;">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" class="text-center">
            <img src="../../assets/images/buyer/03.jpeg" class="buyerimg" />
            <h3 class="buyername">Xiaowang</h3>
            <p>上千次的下单经验，响应时间快，受到买单用户的一致好评</p>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" class="text-center">
            <img src="../../assets/images/buyer/04.jpeg" class="buyerimg" />
            <h3 class="buyername">Dino</h3>
            <p>经验丰富，主要代下英国美国德国订单</p>
          </el-col>
        </el-row>
      </el-carousel-item>
    </el-carousel>

    <el-carousel class="carousel" indicator-position="outside" trigger="click" height="270px" v-else>
      <el-carousel-item v-for="(item,index) in buyers" :key="index">
        <el-row :gutter="0" style="width: 80%;margin: 0 auto;margin-top: 20px;">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" class="text-center">
            <img :src="item.imgsrc" class="buyerimg" />
            <h3 class="buyername">{{item.buyername}}</h3>
            <p>{{item.detail}}</p>
          </el-col>
        </el-row>
      </el-carousel-item>
    </el-carousel>

  </div>
</div>
</template>

<script>
import tit from './Title'

export default {
  name: 'Buyer',
  components: {
    tit: tit
  },
  props: {
    screenWidths: {
      type: Number,
      default: 1024
    },
  },
  data() {
    return {
      search: '',
      buyers: [{
        imgsrc: require('../../assets/images/buyer/01.jpeg'),
        buyername: 'Joy',
        detail: '新手推荐买手，汇率优惠高，服务周到完善，有问必答。'
      }, {
        imgsrc: require('../../assets/images/buyer/02.jpeg'),
        buyername: 'iwaving',
        detail: '人在国内，拥有美卡，英文口语流利，一年多下单经验，涉及200多个商家，能下单部分美卡美私的商家。'
      }, {
        imgsrc: require('../../assets/images/buyer/03.jpeg'),
        buyername: 'Xiaowang',
        detail: '上千次的下单经验，响应时间快，受到买单用户的一致好评'
      }, {
        imgsrc: require('../../assets/images/buyer/04.jpeg'),
        buyername: 'Dino',
        detail: '经验丰富，主要代下英国美国德国订单'
      }]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
    max-width: 1440px;
    margin: 60px auto;
    h3 {
        height: 22px;
        font-size: 20px;
        font-family: PingFangSC-Regular;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
        margin: 10px auto;
    }

    p {
        max-width: 200px;
        height: 66px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        color: rgba(176, 180, 191, 1);
        line-height: 22px;
        margin: 20px auto;
    }
    .carousel {
        margin-bottom: 10px;
    }
    .carousel::-webkit-scrollbar {
        display: none;
    }
    .buyerimg {
        border-radius: 50%;
        width: 80px;
        height: 80px;
        margin-top: 10px;
        margin-bottom: 20px;
    }
    .buyername {
        margin-bottom: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Buyer.vue